import {Component, Input, OnInit} from '@angular/core';
import { ProgressBarMode, MatProgressBar } from "@angular/material/progress-bar";
import { NgClass } from '@angular/common';

@Component({
    selector: 'app-progress-bar',
    templateUrl: './progress-bar.component.html',
    styleUrls: ['./progress-bar.component.scss'],
    imports: [MatProgressBar, NgClass]
})
export class ProgressBarComponent implements OnInit {

  @Input() mode: ProgressBarMode = "determinate";
  @Input() color: ProgressBarType = "primary";
  @Input() value : number;
  constructor() { }

  ngOnInit(): void {
  }

}

export declare type ProgressBarType = 'primary' | 'warn' | 'error' | undefined;
